import styled, { ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { media } from '../theme/base/mixins';
import { StyledComponent } from '../types';
import { Icon } from './Icon';
import { Paragraph } from './Paragraph';
import { Title } from './Title';

export const Footer: StyledComponent = styled.footer`
  background-color: ${(props: ThemeProps<Theme>) =>
    props.theme.colors.footerBg};
  color: ${(props: ThemeProps<Theme>) => props.theme.colors.white};

  ${Paragraph} {
    margin: 0;
  }

  ${Icon} {
    margin: 10px 0;
    width: 100%;
    height: auto;

    svg {
      width: 100%;
      height: auto;
    }

    ${media.medium`
      max-width: 208px;
      max-height: 60px;

      svg {
        max-width: 208px;
        max-height: 60px;
      }
    `}

    ${media.large`
      margin: 0 0 38px;
    `};
  }

  ${Title.Group} {
    margin-bottom: 20px;
  }
`;
